import { Icon, IconColor, IconType, IconSize } from '@doordash/design-language';
import './components/styles/Input.js';
import './components/styles/Time.js';
import { IconContainer } from './components/styles/Select.js';
import './components/styles/Field.js';
import './components/styles/Password.js';
import RawTextField, { RawTextDefaultProps } from './components/RawTextField.js';
import React__default from 'react';
import { SearchFieldSize } from './constants.js';

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SearchField = function SearchField(props) {
  var _props$isResizeable = props.isResizeable,
      isResizeable = _props$isResizeable === void 0 ? RawTextDefaultProps.isResizeable : _props$isResizeable,
      _props$size = props.size,
      size = _props$size === void 0 ? RawTextDefaultProps.size : _props$size,
      _props$isRounded = props.isRounded,
      isRounded = _props$isRounded === void 0 ? RawTextDefaultProps.isRounded : _props$isRounded;
  return /*#__PURE__*/React__default.createElement(RawTextField, _extends({
    __focusBehavior: "default",
    renderBeforeContent: function renderBeforeContent() {
      return /*#__PURE__*/React__default.createElement(IconContainer, null, /*#__PURE__*/React__default.createElement(Icon, {
        color: props.isDisabled ? IconColor.FieldsForegroundDisabled : IconColor.FieldsForegroundActive,
        type: IconType.Search,
        size: IconSize.Medium
      }));
    }
  }, props, {
    isResizeable: isResizeable,
    size: size,
    isRounded: isRounded,
    type: "search" // If they've passed in custom render content, we set this to false. Because we no longer know
    // the dimensions of the rendered content, we want to add top/bottom padding as a buffer
    ,
    hasDefaultRenderContent: props.renderBeforeContent || props.renderAfterContent ? false : true
  }));
};

SearchField.Sizes = SearchFieldSize;

export { SearchField as default };
